/**
 * SALLOGA / Atelier — homepage hero scroll motion
 * Version 1.0 | Shopify theme asset
 * No external dependencies. Does not modify hero.liquid.
 */
(() => {
  'use strict';

  if (!window.matchMedia ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const OPTIONS = {
    desktop: { maxBlur: 6, maxDim: 0.36, movePercent: 2.5, zoomStart: 1.035, zoomEnd: 1.075 },
    mobile:  { maxBlur: 3, maxDim: 0.26, movePercent: 1.5, zoomStart: 1.035, zoomEnd: 1.055 }
  };

  let activeSection = null;
  let activeHero = null;
  let resizeObserver = null;
  let rafId = 0;

  const clamp = (n) => Math.min(1, Math.max(0, n));

  function selectHomepageHero() {
    const main = document.querySelector('#MainContent[data-template="index"]');
    if (!main) return null;

    // Limit this effect to the first TOP-page section, which is the Hero.
    // If other sections are added above it, do not animate an unrelated hero.
    const firstSection = main.querySelector(':scope > .shopify-section');
    if (!firstSection || !firstSection.classList.contains('hero-wrapper')) return null;

    const hero = firstSection.querySelector(':scope > .hero');
    const media = hero?.querySelector('.hero__media-grid');
    if (!hero || !media) return null;

    return { section: firstSection, hero };
  }

  function update() {
    rafId = 0;
    if (!activeSection || !activeHero || !activeSection.isConnected) return;

    const runway = activeSection.offsetHeight - activeHero.offsetHeight;
    if (runway <= 0) return;

    // When the top of the Hero has moved beyond the top of the viewport,
    // the inner sticky Hero stays put while this progress runs from 0 to 1.
    const progress = clamp(-activeSection.getBoundingClientRect().top / runway);
    const opt = window.innerWidth <= 749 ? OPTIONS.mobile : OPTIONS.desktop;

    activeSection.style.setProperty('--salloga-hero-blur', `${(opt.maxBlur * progress).toFixed(2)}px`);
    activeSection.style.setProperty('--salloga-hero-dim', (opt.maxDim * progress).toFixed(3));
    activeSection.style.setProperty('--salloga-hero-y', `${(opt.movePercent * progress).toFixed(2)}%`);
    activeSection.style.setProperty('--salloga-hero-zoom', (opt.zoomStart + (opt.zoomEnd - opt.zoomStart) * progress).toFixed(4));
    activeSection.style.setProperty('--salloga-hero-content-opacity', (1 - 0.90 * progress).toFixed(3));
    activeSection.style.setProperty('--salloga-hero-content-y', `${(18 * progress).toFixed(2)}px`);
    

        activeSection.dataset.sallogaMotionProgress = progress.toFixed(3);
    }

  function requestUpdate() {
    if (!rafId) rafId = window.requestAnimationFrame(update);
  }

  function detach() {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
    if (rafId) {
      window.cancelAnimationFrame(rafId);
      rafId = 0;
    }
    if (activeSection) {
      activeSection.classList.remove('salloga-hero-motion', 'is-ready');
      activeSection.removeAttribute('data-salloga-motion-progress');
      for (const name of [
        '--salloga-hero-blur', '--salloga-hero-dim', '--salloga-hero-y',
        '--salloga-hero-zoom', '--salloga-hero-content-opacity', '--salloga-hero-content-y'
      ]) activeSection.style.removeProperty(name);
    }
    activeSection = null;
    activeHero = null;
  }

  function setup() {
    const found = selectHomepageHero();
    if (found && found.section === activeSection && found.hero === activeHero) {
      requestUpdate();
      return;
    }

    detach();
    if (!found) return;
    activeSection = found.section;
    activeHero = found.hero;
    activeSection.classList.add('salloga-hero-motion', 'is-ready');

    if ('ResizeObserver' in window) {
      resizeObserver = new ResizeObserver(requestUpdate);
      resizeObserver.observe(activeSection);
      resizeObserver.observe(activeHero);
    }
    requestUpdate();
  }

  
document.addEventListener('scroll', requestUpdate, {
  passive: true,
  capture: true
});
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('pageshow', requestUpdate);

  // Shopify theme editor replaces section elements without a full page reload.
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', () => window.setTimeout(setup, 0));
  document.addEventListener('shopify:section:reorder', setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup, { once: true });
  } else {
    setup();
  }

  // Read-only debugging: window.SALLOGAHeroMotion.getState()
  window.SALLOGAHeroMotion = {
    getState: () => ({
      enabled: !!activeSection,
      progress: activeSection?.dataset.sallogaMotionProgress ?? null
    }),
    refresh: setup
  };
})();